import { Box, Chip, Avatar } from "@mui/material";
import { envConfig } from "../../../config/env.config";
import { useTranslation } from "react-i18next";

export default function UserWorkflowInfo({
  name,
  avatar,
  total_task,
  isShowTotal
}: {
  name: string;
  avatar?: string | null;
  total_task?: number;
  isShowTotal?: boolean;
}) {
  const { t } = useTranslation();

  // Build full avatar URL
  const avatarUrl = avatar ? `${envConfig.MEDIA_ENDPOINT}${avatar}` : undefined;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        gap: "12px",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px"
      }}
    >
      <Chip
        avatar={
          <Avatar sx={{ margin: "0 !important" }} alt={name} src={avatarUrl}>
            {!avatarUrl && name ? name.charAt(0).toUpperCase() : ""}
          </Avatar>
        }
        label={name || "Unknown"}
        variant="outlined"
        sx={{
          backgroundColor: "#FFFFFF",
          fontSize: "14px",
          fontWeight: "500",
          color: "#021C5E",
          border: "1px solid #EDEDED",
          padding: "0 4px"
        }}
      />
      {isShowTotal && total_task !== undefined && (
        <span style={{ color: "#021C5E", fontSize: 14, fontWeight: "500" }}>
          {total_task} {t("Management.Task")}
        </span>
      )}
    </div>
  );
}
